import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions';
import flattenAmountBifurcation from '../../utils/flattenAmountBifurcation';
import { getDoctorDisplayName, formatDisplayDate, formatTime } from '../../utils/docConsultUtils';
import { BIFURCATION_TYPE_CART_TOTAL, BIFURCATION_TYPE_DISCOUNT, BIFURCATION_TYPE_PROMO_DISCOUNT, BIFURCATION_TYPE_TOTAL_PAYABLE } from '../../constants';
import './DocConsultRHS.scss';
import '../DiagnosticsCart/DiagnosticsPromoBox.scss';
import '../DiagnosticsCart/CartFooter.scss';

const staticText = {
  heading: 'Consultation Summary',
  cartTotal: 'Cart Total',
  discount: 'Discount',
  amountToBePaid: 'Amount to be paid',
  totalItems: 'Total Items',
  totalSavings: 'Total Savings',
  totalCartValue: 'Total Cart Value',
  promoPlaceholder: 'Enter promocode here',
  apply: 'APPLY',
  remove: 'REMOVE',
  promoApplied: 'Promo applied!',
  invalidCode: 'Invalid Code!',
  speaks: 'Speaks: ',
  yrsExp: 'yrs exp',
  timePrefix: 'Time: ',
  fallbackInitial: '?',
  fallbackDash: '—',
  fallbackSavings: '₹0',
  errorMessage: 'Error applying promo. Please try again.',
};

function buildBifurcationParams(selectedDoctor, consultMode, promoCode) {
  const params = {
    removeAllCharges: true,
    walletOptedIn: 0,
    refundOptIn: 0,
    consultationType: (consultMode || 'VIDEO').toLowerCase(),
    checkout: 0,
    doctorId: selectedDoctor.id,
    price: {
      consultationFee: String(selectedDoctor.consultationFees || 0),
      discountedFee: String(selectedDoctor.consultationFees || 0),
    },
    vendorId: selectedDoctor.vendorId,
    isConsultCorporateWalletOptedIn: 0,
  };
  if (promoCode) {
    params.promoCode = promoCode;
  }
  return params;
}

class DocConsultRHS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promoInput: '',
      promoApplied: false,
      promoMessage: '',
      promoLoading: false,
    };
  }

  applyPromo = async () => {
    const { promoInput, promoLoading } = this.state;
    if (promoLoading) return;
    if (!promoInput || promoInput.length < 3) {
      this.setState({ promoMessage: staticText.invalidCode });
      return;
    }
    const { docConsult, actions } = this.props;
    const { selectedDoctor, consultMode } = docConsult;

    this.setState({ promoLoading: true, promoMessage: '' });

    try {
      const response = await actions.fetchDocConsultBifurcation(
        buildBifurcationParams(selectedDoctor, consultMode, promoInput)
      );

      const isPromoValid = response && response.promotionDetails && response.promotionDetails.isValid;
      const promoMessage = response && response.promotionDetails && response.promotionDetails.message;

      if (isPromoValid) {
        actions.setDocConsultAppliedPromo(promoInput);
        this.setState({
          promoApplied: true,
          promoLoading: false,
          promoMessage: staticText.promoApplied,
        });
      } else {
        this.setState({
          promoApplied: false,
          promoLoading: false,
          promoMessage: promoMessage || staticText.invalidCode,
        });
      }
    } catch (error) {
      this.setState({
        promoApplied: false,
        promoLoading: false,
        promoMessage: staticText.errorMessage,
      });
    }
  }

  removePromo = () => {
    const { docConsult, actions } = this.props;
    const { selectedDoctor, consultMode } = docConsult;
    this.setState({ promoInput: '', promoApplied: false, promoMessage: '', promoLoading: false });
    actions.fetchDocConsultBifurcation(
      buildBifurcationParams(selectedDoctor, consultMode, null)
    );
    actions.setDocConsultAppliedPromo('');
  }

  render() {
    const { docConsult } = this.props;
    const { promoInput, promoApplied, promoMessage, promoLoading } = this.state;
    const {
      selectedDoctor,
      selectedSlot,
      selectedDate,
      bifurcationData,
      bifurcationLoading,
    } = docConsult;

    if (!selectedDoctor) return <div className="dcRHS" />;

    const { firstName, specialization, yearsOfExperience, language, profileUrl } = selectedDoctor;
    const displayName = getDoctorDisplayName(selectedDoctor);
    const initials = firstName ? firstName[0].toUpperCase() : staticText.fallbackInitial;
    const langs = Array.isArray(language) ? language.join(', ') : language;
    const slotTime = selectedSlot ? formatTime(selectedSlot.start) : null;
    const dateLabel = selectedDate ? formatDisplayDate(selectedDate) : '';
    const slotLabel = slotTime
      ? (staticText.timePrefix + (dateLabel ? dateLabel + ', ' : '') + slotTime)
      : null;

    const invoice = flattenAmountBifurcation((bifurcationData && bifurcationData.amountBifurcation) || []);
    // type BIFURCATION_TYPE_CART_TOTAL = subtotal/cart total, BIFURCATION_TYPE_TOTAL_PAYABLE = total payable, BIFURCATION_TYPE_DISCOUNT/BIFURCATION_TYPE_PROMO_DISCOUNT = discount
    const cartTotalItem = invoice.find(bifurcationItem => bifurcationItem.type === BIFURCATION_TYPE_CART_TOTAL);
    const discountItem = invoice.find(bifurcationItem => bifurcationItem.type === BIFURCATION_TYPE_DISCOUNT || bifurcationItem.type === BIFURCATION_TYPE_PROMO_DISCOUNT);
    const totalItem = invoice.find(bifurcationItem => bifurcationItem.type === BIFURCATION_TYPE_TOTAL_PAYABLE) || invoice[invoice.length - 1] || null;
    // for footer summary
    const savingsDisplay = discountItem ? (discountItem.displayValue || discountItem.finalValue) : null;

    return (
      <div className="dcRHS">
        <div className="dcScrollArea">

          <p className="dcHeading">{staticText.heading}</p>

          <div className="dcCard">
            <div className="dcCardInner">
              {profileUrl ? (
                <img src={profileUrl} alt={displayName} className="dcCardImg" />
              ) : (
                <div className="dcCardPlaceholder">{initials}</div>
              )}
              <div className="dcCardDetails">
                <h3 className="dcCardName">{displayName}</h3>
                {specialization && <p className="dcCardSpec">{specialization}</p>}
                {slotLabel && <p className="dcCardMeta">{slotLabel}</p>}
                {yearsOfExperience && <p className="dcCardMeta">{yearsOfExperience} {staticText.yrsExp}</p>}
                {langs && <p className="dcCardMeta">{staticText.speaks}{langs}</p>}
              </div>
            </div>
          </div>

          {!bifurcationLoading && invoice.length > 0 && (
            <div className="dcBifurcationTable">
              <div className="dcBifurcationRow">
                <span>{staticText.cartTotal}</span>
                <span>{cartTotalItem ? (cartTotalItem.displayValue || cartTotalItem.finalValue) : (selectedDoctor.consultationFees ? `₹${selectedDoctor.consultationFees}` : staticText.fallbackDash)}</span>
              </div>
              <div className="dcBifurcationRow">
                <span>{staticText.discount}</span>
                <span>{discountItem ? (discountItem.displayValue || discountItem.finalValue) : staticText.fallbackDash}</span>
              </div>
              <div className="dcBifurcationRow">
                <span>{staticText.amountToBePaid}</span>
                <span>{totalItem ? (totalItem.displayValue || totalItem.finalValue) : staticText.fallbackDash}</span>
              </div>
            </div>
          )}

        </div>

        {/* Footer — same UI as DiagnosticsCart CartFooter, outside scroll area */}
        <div className="footerDetails">
          <div className="DiagnosticsPromoBoxContainer">
            <div className="InputContainer">
              <input
                type="text"
                value={promoInput}
                placeholder={staticText.promoPlaceholder}
                disabled={promoApplied}
                onChange={e => this.setState({ promoInput: e.target.value, promoMessage: '' })}
                onKeyPress={e => e.which === 13 && !promoApplied ? this.applyPromo() : null}
              />
              <button
                className={promoLoading ? 'loading' : ''}
                onClick={promoApplied ? this.removePromo : this.applyPromo}
              >
                {promoApplied ? staticText.remove : staticText.apply}
              </button>
            </div>
            {promoApplied
              ? <div className="SuccessText">{promoMessage}</div>
              : <div className="ErrorText">{promoMessage}</div>
            }
          </div>

          <div className="summary">
            <div className="itemContainer">
              <div className="textTitle">{staticText.totalItems}</div>
              <div className="textTitle textbold">1</div>
            </div>
            <div className="itemContainer">
              <div className="textTitle textGreen">{staticText.totalSavings}</div>
              <div className="textTitle textbold textGreen">
                {savingsDisplay || staticText.fallbackSavings}
              </div>
            </div>
            <div className="itemContainer">
              <div className="textTitle">{staticText.totalCartValue}</div>
              <div className="textTitle textbold">
                {totalItem ? (totalItem.displayValue || totalItem.finalValue) : staticText.fallbackDash}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DocConsultRHS.propTypes = {
  docConsult: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default connect(
  state => ({ docConsult: state.docConsult }),
  dispatch => ({ actions: bindActionCreators(actions, dispatch) })
)(DocConsultRHS);
